import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  constructor(    private router: Router,
  ) { }

  ngOnInit() {
  }

  validateLogin () {
    this.router.navigate(['/subjects' ]); // use this url
  }
}



// WEBPACK FOOTER //
// ./src/app/login-page/login-page.component.ts